<template>
  <div class="member-section">
    <div class="member-img-wrapper">
      <img src="@/assets/img/about/all_member_alt.jpg" alt="伊豆大島合宿メンバー" />
    </div>
    <div class="member-text-wrapper">
      <SectionTitle heading="We are" />
      <p>
        学生時代の友人。伊豆大島によく釣り合宿に行っている。
        釣った魚を自分たちで料理して美味しくいただいている。
        <br>
        このサイトは勉強のためにオーバーエンジニアリングになりつつも、苦労しながら一からつくった。
        <br>
        釣り合宿の仲間はいつでも募集しています。
      </p>
    </div>
  </div>
</template>

<script>
import SectionTitle from "@/features/about/components/SectionTitle.vue";

export default {
  components: { SectionTitle },
};
</script>

<style scoped>
.member-section {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.member-img-wrapper {
  width: 50%;
  height: auto;
  display: flex;
  justify-content: center;
}

.member-img-wrapper img {
  width: 90%;
  object-fit: cover;
}

.member-text-wrapper {
  width: 50%;
  height: auto;
  font-family: sans-serif;
}

.member-text-wrapper p {
  font-size: 13px;
  line-height: 2rem;
}

@media screen and (max-width: 570px) {
  .member-section {
    flex-direction: column-reverse;
  }

  .member-img-wrapper {
    width: 100%;
  }

  .member-img-wrapper img {
    width: 100%;
  }

  .member-text-wrapper {
    width: 100%;
  }

  .member-text-wrapper p {
    font-size: 12px;
    line-height: 1.5rem;
  }
}
</style>